/**
 * @file  src\components\Inventory\CreateInventory\InventoryRightSection.js
 * @brief  This file is responsible for  inventory creation right section
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect } from "react";
import TopRightBtn from "../../MemberWantAd/TopRightBtn";
import BottomNavBar from "../../MemberWantAd/BottomNavBar";
import InventoryStartPage from "./InventoryStartPage";
import InventoryPropertyTypes from "./InventoryPropertyTypes";
import InventoryNiceToHaves from "./InventoryNiceToHaves";
import InventoryLandNiceToHaves from "./InventoryLandNiceToHaves";
import InventoryConfirmation from "./InventoryConfirmation";
import InventoryMemberStrengthen from "../../Inventory/StengthenInventory/InventoryMemberStrengthen";
import { getInventoryMyDrafts } from "../../../services/inventoryService";
import {
  USER_INFO_KEY,
  INVENTORY_KEY,
  IS_LAND,
  INVENTORY_SELL,
} from "../../../constants/common";
import { getLocalStorage } from "../../../helpers/common";
import { convertToNumber } from "../../../helpers/validations";
import { InventoryLocationMapAndForm } from "@/components/Inventory/PropertyLocationForm/InventoryLocationMapAndForm";
import InventoryBudget from "./InventoryBudget";
import InventoryFileUpload from "./InventoryFileUpload";

const InventoryRightSection = (props) => {
  const {
    skipButtonEnable,
    exitButtonText,
    backButtonEnable,
    handleContinueClick,
    handleBackButtonClick,
    handleContinueButtonState,
    isDisabled,
    handleSaveAndExit,
    handleFormValues,
    handleSkipButtonClick,
    step,
    formValues,
    continueButtonText,
    className,
    bottomNavClass,
    clearPreviousStates,
    exitButtonDisable,
    backButtonText,
    hideContinueButton,
    isStrengthenInventory,
    setActiveStep,
    setDraftSelectedItem,
    draftSelectedItem,
  } = props;

  const propertyType = convertToNumber(_.get(formValues, "prprtyType", null));
  const propertySubType = convertToNumber(
    _.get(formValues, "prptySubType", null)
  );
  const propertyPurpose = _.get(formValues, "proprtyPurpose", "");

  const [myDrafts, setMyDrafts] = useState();
  useEffect(() => {
    if (!isStrengthenInventory && step === 1) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      const userId = _.get(userDetails, "userInfo.userId", null);
      getInventoryMyDrafts()
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (responseResult && responseResult.length !== 0) {
            setMyDrafts(responseResult);
          } else {
            setActiveStep(2);
            setMyDrafts({});
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  }, []);

  const loadStartingPage = () => {
    const inventory = getLocalStorage(INVENTORY_KEY);
    if (!isStrengthenInventory) {
      if (step === 1) {
        if (myDrafts) {
          if (myDrafts.length > 0) {
            return (
              <InventoryStartPage
                handleContinueClick={handleContinueClick}
                handleContinueButtonState={handleContinueButtonState}
                myDraft={myDrafts}
                setDraftSelectedItem={setDraftSelectedItem}
                draftSelectedItem={draftSelectedItem}
              />
            );
          } else {
            return (
              <InventoryPropertyTypes
                handleContinueButtonState={handleContinueButtonState}
                handleFormValues={handleFormValues}
                propertyType={propertyType}
                adType={_.get(formValues, "adType", null)}
                clearPreviousStates={clearPreviousStates}
                prptySubType={propertySubType}
              />
            );
          }
        }
      } else if (
        (_.get(inventory, "actvStep", "") ||
          _.get(inventory, "cmpldStep", "")) &&
        step === 2
      ) {
        return (
          <InventoryPropertyTypes
            handleContinueButtonState={handleContinueButtonState}
            handleFormValues={handleFormValues}
            propertyType={propertyType}
            adType={_.get(formValues, "adType", null)}
            clearPreviousStates={clearPreviousStates}
            prptySubType={propertySubType}
          />
        );
      }
    }
  };

  const renderFlow = () => {

    if (isStrengthenInventory) {
      return (
        <InventoryMemberStrengthen
          formValues={formValues}
          step={step}
          handleContinueButtonState={handleContinueButtonState}
          handleFormValues={handleFormValues}
          handleContinueClick={handleContinueClick}
        />
      );
    } else {
      switch (step) {
        case 3:
          return (
            <div className="center-content-sec mw-524">
              <div className="wantad-location-wrap mb-3">
                <InventoryLocationMapAndForm
                  formValues={formValues}
                  handleFormValues={handleFormValues}
                  isAgentCreated={false}
                  propertyType={propertyType}
                />
              </div>
            </div>
          )

        case 4:
          if (propertyType === IS_LAND) {
            return (
              <InventoryLandNiceToHaves
                handleContinueButtonState={handleContinueButtonState}
                handleFormValues={handleFormValues}
                nice2Have={_.get(formValues, "nice2Have", null)}
              />
            );
          } else {
            return (
              <InventoryNiceToHaves
                handleContinueButtonState={handleContinueButtonState}
                handleFormValues={handleFormValues}
                nice2Have={_.get(formValues, "nice2Have", [])}
                propertyPurpose={propertyPurpose}
              />
            );
          }

        case 5:
          return (
            <InventoryBudget
              handleContinueButtonState={handleContinueButtonState}
              handleFormValues={handleFormValues}
              sellAskngPrice={_.get(formValues, "sellAskngPrice", "")}
              LTRAskngPrce={_.get(formValues, "LTRAskngPrce", "")}
              STRAskngPrce={_.get(formValues, "STRAskngPrce", "")}
              isCompnsteAgent={_.get(formValues, "isCompnsteAgent", "")}
              isCompnsteAgentLTR={_.get(formValues, "isCompnsteAgent_LTR", "")}
              isCompnsteAgentSTR={_.get(formValues, "isCompnsteAgent_STR", "")}
              propertyPurpose={propertyPurpose}
              salesPercnt={_.get(formValues, "salesPercnt", null)}
              salesPercntLTR={_.get(formValues, "salesPercnt_LTR", null)}
              salesPercntSTR={_.get(formValues, "salesPercnt_STR", null)}
              zestimate={_.get(formValues, "zestimate", null)}
              invType={INVENTORY_SELL}
            />
          );

        case 6:
          return (
            <InventoryFileUpload
              handleContinueButtonState={handleContinueButtonState}
              handleFormValues={handleFormValues}
              photos={_.get(formValues, "photos", [])}
              s3Imagefolder={_.get(formValues, "s3Imagefolder", "")}
              isFolderCreated={_.get(formValues, "isFolderCreated", "")}
            />
          );

        case 7:
          return (
            <InventoryConfirmation
              handleContinueButtonState={handleContinueButtonState}
              formValues={formValues}
            />
          );
      }
    }
  };

  return (
    <div className="col-lg-7 offset-lg-5 right-pane-bg">
      <div
        className={
          className ? "right-pane-content " + className : "right-pane-content"
        }
      >
        <TopRightBtn
          exitButtonText={exitButtonText}
          handleSaveAndExit={handleSaveAndExit}
          exitButtonDisable={exitButtonDisable}
          step={step}
        />
        {loadStartingPage()}
        {renderFlow()}

        <BottomNavBar
          skipButtonEnable={skipButtonEnable}
          backButtonEnable={
            _.get(formValues, "isPublished", "") == 1 ? false : backButtonEnable
          }
          handleContinueClick={handleContinueClick}
          handleBackButtonClick={handleBackButtonClick}
          isDisabled={isDisabled}
          handleSkipButtonClick={handleSkipButtonClick}
          step={step}
          continueButtonText={continueButtonText}
          bottomNavClass={bottomNavClass}
          backButtonText={backButtonText}
          hideContinueButton={hideContinueButton}
        />
      </div>
    </div>
  );
};

export default InventoryRightSection;
